export default (axios) => async (excursionType, filterBy, oauthSignature, clientSid) => {
  const url = `/v2/clients/${encodeURIComponent(clientSid)}/risk-categories`;

  const params = {
    'oauth-signature': oauthSignature,
    excursionType
  };

  if (filterBy) {
    params.filterBy = filterBy;
  }

  const axiosConfig = {
    method: 'GET',
    url,
    params
  };
  const axiosResponse = await axios(axiosConfig);

  if (!axiosResponse || !axiosResponse.data || typeof axiosResponse.data !== 'object') {
    throw new Error('Invalid response from gateway');
  }
  return axiosResponse.data;
};
